<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4">
                            <h4 class="page-title">
                                {{ $t('string.msg.company.gas.station.list.label.title') }}
                            </h4>
                        </h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{ $t('str.total') }}</h4>
                        <h4 class="text-center" style="color: grey">{{ items.length }}</h4>
                    </div>
                </div>

                <p class="sub-header">
                    {{ $t('string.msg.companies.gas.station.search.description') }}
                </p>

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label class="col-form-label">
                                <code class="highlighter-rouge">*</code>
                                {{ $t('string.msg.company.label.status') }}
                            </label>
                            <select v-model="filters.status" class="form-control">
                                <option :value="null" selected>
                                    {{ $t('string.msg.element.select.selectitem') }}
                                </option>
                                <option value="ACTIVE">{{ $t('string.msg.active') }}</option>
                                <option value="ARCHIVED">
                                    {{ $t('string.msg.archived') }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group col-md-4">
                            <label for="inputAddress" class="col-form-label"> Razão Social, Nome Fantasia ou CNPJ </label>
                            <!--<input type="text" v-model="filters.name" class="form-control" @input="onChangeName($event)">-->
                            <autocomplete :search="onChangeName" :get-result-value="getResultValue" @submit="submitFilter" debounceTime="500"></autocomplete>
                        </div>
                    </div>

                    <br />
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">
                            {{ $t('string.msg.form.btn.search') }}
                        </button>
                        <div v-if="items && items.length > 0">
                            <download-excel v-if="filters.typeService == ''" class="btn btn-primary" :fetch="fetchData" :fields="json_fields" :meta="json_meta" type="csv" name="associados-geral.xls">
                                Download CSV
                            </download-excel>
                            <download-excel
                                v-else-if="filters.typeService == 'PART_SUPPLIER'"
                                class="btn btn-primary"
                                :fetch="fetchData"
                                :fields="json_fields"
                                :meta="json_meta"
                                type="csv"
                                name="auto-peças.xls"
                            >
                                Download CSV
                            </download-excel>
                            <download-excel
                                v-else-if="filters.typeService == 'CERTIFIER'"
                                class="btn btn-primary"
                                :fetch="fetchData"
                                :fields="json_fields"
                                :meta="json_meta"
                                type="csv"
                                name="certificadoras.xls"
                            >
                                Download CSV
                            </download-excel>
                            <download-excel
                                v-else-if="filters.typeService == 'SERVICE_PROVIDER'"
                                class="btn btn-primary"
                                :fetch="fetchData"
                                :fields="json_fields"
                                :meta="json_meta"
                                type="csv"
                                name="prestadores-serviço.xls"
                            >
                                Download CSV
                            </download-excel>
                            <download-excel v-else-if="filters.typeService == 'FLEET_DRIVER'" class="btn btn-primary" :fetch="fetchData" :fields="json_fields" :meta="json_meta" type="csv" name="frotistas.xls">
                                Download CSV
                            </download-excel>
                        </div>
                    </div>
                </form>

                <div class="pb-0 pt-3 cursor-pointer">
                    <jw-pagination :items="items" @changePage="onChangePage" :labels="customLabels"></jw-pagination>
                </div>
                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0"></th>
                                <th class="border-top-0">
                                    {{ $t('string.msg.company.label.fantasyName') }}
                                </th>
                                <th class="border-top-0">
                                    {{ $t('string.msg.company.label.document') }}
                                </th>
                                <th class="border-top-0">
                                    {{ $t('string.msg.company.label.main.email') }}
                                </th>
                                <th class="border-top-0">
                                    {{ $t('string.msg.company.label.primaryPhone') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer" @click="selectItem(item)">
                                <td>
                                    <span v-if="item.logoURL && item.logoURL !== String('https://')">
                                        <img v-if="item.logoURL" v-bind:src="`${domain}${item.logoURL}`" alt="image" height="80" width="80" />
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.fantasyName">
                                        {{ toUpperCase(item.fantasyName) }}
                                    </span>
                                </td>
                                <td>
                                    <input v-show="item.document" type="tel" readonly v-mask="['###.###.###-##', '##.###.###/####-##']" class="form-control reset-input" :value="item.document" />
                                </td>
                                <td>
                                    <span v-if="item.email">
                                        {{ item.email }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.primaryPhone">
                                        {{ item.primaryPhone }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" />
    </div>
</template>

<script>
import Controller from './CrtListGasStation'
import Toast from '../../../components/layout/Toast'
import Spinner from '../../../components/layout/Spinner'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination'
import Vue from 'vue'

Vue.component('jw-pagination', JwPagination)
Vue.component('downloadExcel', JsonExcel)

Vue.prototype.$eventHub = new Vue()
export default {
    name: 'ListGasStation',
    props: ['valuekey'],
    watch: {
        valuekey() {},
    },
    components: {
        Toast,
        Spinner,
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            PageNumbers: 1,
            items: [],
            pageOfItems: [],
            companiesSuggest: null,
            filters: {
                typeService: 'GAS_STATION',
                name: '',
                status: 'ACTIVE',
            },
            json_fields: {
                'Nome Fantasia': 'fantasyName',
                Telefone: 'primaryPhone',
                Email: 'email',
                CNPJ: 'document',
            },
            json_data: [
                {
                    companyUser: {
                        company: {
                            fantasyName: null,
                            primaryPhone: null,
                            email: null,
                            document: null,
                        },
                    },
                },
            ],
            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8',
                    },
                ],
            ],
            customLabels: {
                first: 'Primeira',
                last: 'Último',
                previous: 'Anterior',
                next: 'Próxima',
            },
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
        let state = this
        this.$eventHub.$on('refreshList', function () {
            state.filter()
        })
    },
    mounted() {},
}
</script>

<style>
.autocomplete-input {
    border: 1px solid rgb(217, 217, 217) !important;
    border-radius: 8px;
    width: 100%;
    padding: 12px 12px 12px 48px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    font-size: 16px;
    line-height: 1.5;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 38px;
    background-color: #fff !important;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: 12px;
}
</style>
